<template>
  <div class="home">
    <top-navigation ref="topNav"
                    navBg="#fff"
                    :isHome="false"></top-navigation>
    <div style="height:75px"></div>
    <el-image v-if="swiperList && swiperList.length!=0"
              style="min-width: 1200px;height:463px;"
              :src="swiperList[0].resourceUrl"
              alt=""></el-image>
    <div class="box">
      <div class="currency_box">
        <curTitle color="#333333"
                  :data="{title:'浏览标杆案例'}"></curTitle>
      </div>
      <div class="currency_box">
        <div style="flex:1;text-align:center">
          <el-button v-for="(item,index) in top_nav"
                     type="danger"
                     round
                     :plain="topIndex == item.value?false:true"
                     @click="topClick(item)"
                     :key="index">{{item.text}}</el-button>
        </div>
      </div>
      <div class="currency_boxs"
           v-loading="loading"
           v-for="(item,index) in calssifyList"
           :key="index+'calss'">
        <div class="title font32">{{item.text}}</div>
        <Item :data="item.tempDeta"></Item>
      </div>
      <!-- <div class="currency_box"
           v-if="calssifyList.length==0">
        <el-empty style="width: 100%;"
                  description="暂无案例"></el-empty>
      </div> -->
    </div>
  </div>
</template>

<script>
import Item from './components/item.vue'
import ItemOne from './components/item-one.vue'
import curTitle from '@/components/home/cur_title.vue'
import {
  resourceList, projectClassify, dictTypeList, allArticleList
} from '@/api/api.js'
export default {
  components: { Item, curTitle, ItemOne },
  data () {
    return {
      loading: false,
      top_nav: [{ text: '活动案例', value: 1 }, { text: '项目案例', value: 2 }],
      topIndex: 1,
      swiperList: [],
      data: {
        showIndex: 6,
        pageNumber: 1,
        pageSize: 100
      },
      articleData: {  //文章
        articleClassify: '',
        pageNumber: 1,
        pageSize: 3
      },
      articleClassifyList: [],  //字典项
      calssifyList: []
    }
  },
  created () {
    this.getresourceList()
    this.getDictTypeList()
  },
  methods: {
    topClick (item) {
      this.topIndex = item.value;
      this.getprojectClassify()

    },
    // 字典项 ow_article_classify
    async getDictTypeList () {
      const res = await dictTypeList('ow_article_classify')
      this.articleClassifyList = res.data
      this.getprojectClassify()
      console.log(res)
    },
    async getprojectClassify () {
      this.calssifyList = [];
      const res = await projectClassify(this.topIndex)
      let list = res.data;
      if (list && list.length != 0) {
        list.forEach((x, y) => {
          this.articleClassifyList.forEach((item, index) => {
            if (item.paramValue == x.articleClassifyIds) {
              x['text'] = item.paramName
              if (y <= 4) {
                this.getallArticleList(x, y)
              }
            }
          })
        })
      }
      // this.calssifyList = list;
      // if (this.calssifyList && this.calssifyList.length != 0) {
      //   // this.articleData.articleClassify = this.calssifyList[0].articleClassify
      //   this.calssifyList.forEach((item, index) => {
      //     if (index <= 4) {
      //       this.getallArticleList(item, index)
      //     }
      //   })
      //   // this.getallArticleList()
      // }
      // console.log(this.calssifyList)
    },
    async getallArticleList (item, index) { //
      this.articleData.articleClassify = item.articleClassifyIds;
      console.log(this.articleData)
      this.loading = true;
      const res = await allArticleList(this.articleData)
      let arr = {
        bg: '#fff',
        itembg: '#f6f6f6',
        status: 'more'
      }
      let ow = { ...arr, ...res.data }
      let temparr = { ...item, ...{ tempDeta: ow } }
      this.$nextTick(() => {
        this.calssifyList.push(temparr)
      })
      this.loading = false;
      console.log(this.calssifyList)

    },
    async getresourceList () {  //获取首页资源
      const res = await resourceList(this.data)
      console.log(res)
      this.swiperList = res.data;
    },
  }
}
</script>

<style lang="less" scoped>
.home {
  position: relative;
  min-height: 100vh;
  background-color: #fff;
  .title {
    color: #333;
    font-weight: bold;
  }
  .box {
    min-width: 1200px;
    background-color: #fff;
  }
}
</style>
